module.exports = new __parcel__URL__("mission_default_text.9d62981d.png").toString();